<template>
  <div class="fee-edit">
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="120px" :inline-message="true" :hide-required-asterisk="false">
        <div>
          <el-form-item label="是否全部专业进行调整" label-width="200px" prop="isAllUpdate" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isAllUpdate">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.isAllUpdate">
            <div style="color: red;">
              对未进行申请、审核未通过和审核通过的专业同步调整
            </div>
            <div style="font-weight: bold;">
              全部专业
              <i class="icon icon_arrow-down-filling"></i>
            </div>
            <div v-for="(item,index) in specialtyList" :key="index" class="inline-block" style="margin-right: 10px;margin-top: 10px;">{{item.specialtyName}}</div>
          </div>
          <div v-else style="font-weight: bold;">
            {{this.form.categoryName}} {{this.form.specialtyName}}
          </div>
          <el-form-item label="上调比例要求">
            {{form.feeLowerRate}}%-{{form.feeUpperRate}}%
          </el-form-item>
          <el-table :data="form.gradeList" stripe size="medium" :max-height="300">
            <el-table-column prop="gradeName" label="级别"></el-table-column>
            <el-table-column prop="originalFee" label="考级费（不包含基本费用）" width="200">
              <template slot-scope="scope">
                {{scope.row.originalFee}}元
              </template>
            </el-table-column>
            <el-table-column prop="examFee" label="调整后费用">
              <template slot-scope="scope">
                <el-form-item label="" label-width="0px" :prop="'gradeList.'+scope.$index+'.examFee'" :rules="[$validate.integer(false)]">
                  <el-input v-model="scope.row.examFee"
                            @input="e=>scope.row.examFee=Tool.checkNumber(e,Number(scope.row.originalFee)+scope.row.originalFee*form.feeUpperRate/100,0)" placeholder="请输入"
                            style="width: 110px;margin-right: 10px;"></el-input>
                  元
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="feeUpperRate" label="上浮比例" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.originalFee && scope.row.examFee">
                  {{Tool._toFixed((scope.row.examFee-scope.row.originalFee)*100/scope.row.originalFee,0)}}%
                </span>
                <span v-else>0%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
    </div>
    <div class="text-right" style="margin-top: 20px;">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">提交申请</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      specialtyList: []
    }
  },
  async created () {
    await this.initForm(this.row)
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm (row) {
      if (!this.Tool.isNull(row)) {
        let info = JSON.parse(JSON.stringify(row))
        info.isAllUpdate = 0
        this.specialtyList = await this.$HTTP.ApiFeeAudit.getListSpecialty({ batchId: info.batchId })
        this.form = info
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let confirm = await this.$confirm('请确保费用填写无误，提交申请后可在审核管理中查看', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let auditFeeList = []
          for (let i in this.form.gradeList) {
            let item = this.form.gradeList[i]
            let feeUpperRate = 0
            if (Number(item.originalFee) > 0) {
              feeUpperRate = this.Tool._toFixed((item.examFee - item.originalFee) * 100 / Number(item.originalFee), 0)
            }
            if (feeUpperRate <= Number(this.form.feeUpperRate)) {
              auditFeeList.push({
                examFee: Number(item.examFee),
                feeUpperRate: feeUpperRate,
                gradeId: item.gradeId,
                gradeName: item.gradeName
              })
            } else {
              throw new Error(`${item.gradeName}的上调比例超出标准，请重新调整费用`)
            }
          }
          this.form.auditFeeList = auditFeeList
          await this.$HTTP.ApiFeeAudit.add(this.form)
          this.$emit('close', true)
        }
      }
    }
  }
}
</script>
<style>
  .fee-edit .el-form-item {
    margin-bottom: 0px;
  }
</style>
